import { Link, Text, View } from "@react-pdf/renderer";
import LinkedinIcon from "../graphics/LinkedinIcon";
import YoutubeIcon from "../graphics/YoutubeIcon";
import { color } from "../styles";
import { useLocalization } from "../localization/LocalizationContext";

const Footer: React.FC = () => {
  const { strings } = useLocalization();
  const t = strings.footer;

  return (
    <View
      fixed
      style={{
        position: "absolute",
        bottom: 0,
        width: "100%",
        height: 80,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        paddingHorizontal: 20,
        color: color.darkGrey,
      }}
    >
      <View
        style={{
          width: 100,
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Link src="https://www.linkedin.com/company/avs-sverige/">
          <LinkedinIcon width={14} height={14} color={color.grey} />
        </Link>
        <Link src="https://www.youtube.com/@avs-sverige">
          <YoutubeIcon width={16} height={16} color={color.grey} style={{ marginLeft: 5 }} />
        </Link>
        <Text style={{ fontSize: 9, textAlign: "center", width: "100%" }}>@avs-sverige</Text>
      </View>

      <View style={{ width: 300 }}>
        <Text style={{ fontSize: 9, lineHeight: "14px", textAlign: "center" }}>
          AVS i Sverige AB
        </Text>

        <View
          style={{
            fontSize: 9,
            textAlign: "center",
            flexDirection: "row",
            justifyContent: "center",
            gap: 10,
          }}
        >
          <Link src={t.url} style={{ color: color.darkGrey, textDecoration: "none" }}>
            avs.se
          </Link>
          <Text>|</Text>
          <Link src="mailto:post@avs.se" style={{ color: color.darkGrey, textDecoration: "none" }}>
            post@avs.se
          </Link>
          <Text>|</Text>
          <Link src="tel:010-551 10 00" style={{ color: color.darkGrey, textDecoration: "none" }}>
            010-551 10 00
          </Link>
        </View>
      </View>

      <View style={{ width: 100 }}></View>
    </View>
  );
};

export default Footer;
